
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import CabinetsShowcase from './components/CabinetsShowcase';
import About from './components/About';
import Testimonial from './components/Testimonial';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero scrolled={scrolled} />
      <Services />
      <Portfolio />
      <CabinetsShowcase />
      <About />
      <Testimonial />
      <Footer />
    </div>
  );
}
